import React from "react";
import PropTypes from "prop-types";

const DataTable = ({
  data,
  columns,
  renderRow,
  onSort,
  getSortClass,
  renderHeader,
  emptyMessage = "No records found",
  tableClassName = "table clientTable",
  colSpan = 8,
}) => {
  return (
    <div className="table-responsive">
      <table className={tableClassName}>
        <thead>
          <tr>
            {renderHeader ? (
              renderHeader()
            ) : (
              columns?.map((column) => (
                <th key={column.key}>
                  {column?.sortable ? (
                    <button
                      className={getSortClass(column?.sortKey)}
                      onClick={(e) => onSort(e, column?.sortKey)}
                    >
                      {column?.label}
                    </button>
                  ) : (
                    column?.label
                  )}
                </th>
              ))
            )}
          </tr>
        </thead>
        <tbody>
          {data?.length > 0 ? (
            data?.map((item, index) => renderRow(item, index))
          ) : (
            <tr>
              <td
                colSpan={colSpan}
                className="u-text-align-center u-margin-top-bottom-m u-color-red"
              >
                {emptyMessage}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

DataTable.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      sortable: PropTypes.bool,
      sortKey: PropTypes.string,
    })
  ).isRequired,
  renderRow: PropTypes.func.isRequired,
  onSort: PropTypes.func.isRequired,
  getSortClass: PropTypes.func.isRequired,
  renderHeader: PropTypes.func,
  emptyMessage: PropTypes.string,
  tableClassName: PropTypes.string,
  colSpan: PropTypes.number,
};

export default DataTable;
